const getters = {};

/**
 * 포인트 전환 단계 정보
 * @param {*} state
 * @returns {String}
 */
getters.exchangeStep = (state) => state.exchange.exchangeStep;

/**
 * 포인트 전환 비율
 * @param {*} state
 * @returns {Array}
 */
getters.exchangeCurrency = (state) => state.exchange.exchangeCurrency;

/**
 * 포인트 전환 정보
 * @param {*} state
 * @returns {Object}
 */
getters.exchangeInit = (state) => state.exchange.exchangeInit;

/**
 * 연락처 입력 상태 정보
 * @param {*} state
 * @returns {Boolean}
 */
getters.isStateContact = (state) => state.exchange.isStateContact;

/**
 * 은행 리스트
 * @param {*} state
 * @returns {Array}
 */
getters.bankList = (state) => state.exchange.bankList;

/**
 * 은행 이름 리스트
 * @param {*} state
 * @returns {Array}
 */
getters.bankNameList = (state) => state.exchange.bankNameList;

/**
 * 은행 선택 정보
 * @param {*} state
 * @returns {Number}
 */
getters.bankSelect = (state) => state.exchange.bankSelect;

/**
 * 계좌 인증 정보
 * @param {*} state
 * @returns {Object}
 */
getters.exchangeAccountRequest = (state) => state.exchange.exchangeAccountRequest;

/**
 * 계좌 인증 상태 정보
 * @param {*} state
 * @returns {Boolean}
 */
getters.isStateAccount = (state) => state.exchange.isStateAccount;

/**
 * 계좌 인증 화면 상태 정보
 * @param {*} state
 * @returns {Boolean}
 */
getters.isDisplayAccount = (state) => state.exchange.isDisplayAccount;

/**
 * 전환신청 버튼 활성화
 * @param {*} state
 * @returns {Boolean}
 */
getters.exchangeBtnDisabled = (state) => {
  return state.exchange.exchangeRequest.point != '' && state.exchange.isStateContact && state.exchange.isStateAccount;
};

/**
 * 신청 정보
 * @param {*} state
 * @returns {Object}
 */
getters.exchangeRequest = (state) => state.exchange.exchangeRequest;

/**
 * exchange 내역
 * @param {*} state
 * @returns {Array}
 */
getters.exchangeList = (state) => {
  return state.exchange.exchangeList;
};

/**
 * exchange 내역 페이지 사이즈
 * @param {*} state
 * @returns {Number}
 */
getters.exchangeListPageSize = (state) => {
  return state.exchange.exchangeListPageSize;
};

/**
 * exchange 내역 현재 페이지
 * @param {*} state
 * @returns {Number}
 */
getters.exchangeListPageNo = (state) => {
  return state.exchange.exchangeListPageNo;
};

/**
 * exchange 내역 시작일
 * @param {*} state
 * @returns {String}
 */
getters.exchangeListStartDate = (state) => {
  return state.exchange.exchangeListStartDate;
};

/**
 * exchange 내역 종료일
 * @param {*} state
 * @returns {String}
 */
getters.exchangeListEndDate = (state) => {
  return state.exchange.exchangeListEndDate;
};

/**
 * exchange 내역 상태
 * @param {*} state
 * @returns {Number}
 */
getters.exchangeListStatus = (state) => {
  return state.exchange.exchangeListStatus;
};

/**
 * exchange 상세 내역
 * @param {*} state
 * @returns {Number}
 */
getters.exchangeDetail = (state) => {
  return state.exchange.exchangeDetail;
};

/**
 * exchange 상세 내역
 * @param {*} state
 * @returns {Boolean}
 */
getters.isDetailAccount = (state) => {
  return state.exchange.isDetailAccount;
};

getters.isNjPointWithdraw = (state) => {
  return state.exchange.isNjPointWithdraw;
};

export default {
  ...getters,
};
